export default "__VITE_ASSET__40df9b56__"